import { initImageErrorFallback } from "common/jiffy/image-error-fallback";
import "common/ajax_status";
import "common/customer/autofocus";
import initPrint from "common/customer/print";
import initTooltipOnLoad from "common/customer/tooltip";
import {
  isCheckIsFirstTimeVisitor,
  removeTidioChatScript
} from "common/customer/first-time-visitor";
import { getCleanPath, isProductDetailsPage } from "common/utils/detect-page-type/page-type";

// Must run at module scope (not DOMContentLoaded) so the capture-phase error
// listener registers before initial-HTML images can fail.
initImageErrorFallback();

document.addEventListener("DOMContentLoaded", () => {
  initPrint();
  initTooltipOnLoad();

  if (!isProductDetailsPage(getCleanPath())) {
    isCheckIsFirstTimeVisitor() && removeTidioChatScript();
  }
});
